import React from "react";
import { Pagination } from "react-bootstrap";
const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
  const startPage = Math.max(1, currentPage - 2);
  const endPage = Math.min(totalPages, startPage + 4);

  return (
    <Pagination size="sm">
      <Pagination.First
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      />
      <Pagination.Prev
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
      />
      {currentPage > 3 && <Pagination.Ellipsis />}
      {Array.from({ length: endPage - startPage + 1 }).map((_, index) => (
        <Pagination.Item
          key={startPage + index}
          active={startPage + index === currentPage}
          onClick={() => onPageChange(startPage + index)}
        >
          {startPage + index}
        </Pagination.Item>
      ))}
      {currentPage < totalPages - 2 && <Pagination.Ellipsis />}

      <Pagination.Next
        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
        disabled={currentPage === totalPages}
      />
      <Pagination.Last
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      />
    </Pagination>
  );
};

export default CustomPagination;
